import styled from '@emotion/styled'
import { typography } from './system-props'
import Box from './box'

const Text = styled(Box)`
  ${typography}
`

export default Text
